import {ApiModel} from '@models/api-model';
import {TechnicalDeviceNamespace} from '@namespaces/technical-device.namespace';
import {UploadedFile} from '@interfaces/file.interface';
import {RoutesStorage} from '@helpers/routes.helper';
import {AjaxDownloadQueueItem} from '@components/ajax-download-noty/ajax-download.service';

export interface ConclusionInfo {
    id: number;
    methodTitle: string;
    numberTitle: string;
    technicalCardId: number;
    date: string;
    statusTitle: string;
    scan: UploadedFile;
    isBlank: boolean;
    withInspections: boolean;
    /**
     * Состояние для генерации и скачивания заявки
     */
    downloadButtonState$?: AjaxDownloadQueueItem;
    newUrl?: string;
    viewUrl?: string;
    editUrl?: string;
}

export class TechnicalDeviceElement extends ApiModel<TechnicalDeviceNamespace.Element> {
    id: number;

    /**
     * Информация по параметрам элемента для вывода в интерфейсе
     */
    paramsInfo: string;

    conclusions: ConclusionInfo[] = [];

    constructor(
        data: TechnicalDeviceNamespace.Element
    ) {
        super(data);
        this.setAttributes();
    }

    protected setAttributes() {
        this.id = this.rawData.id;

        if (this.rawData.params && this.rawData.params.length) {
            this.paramsInfo = this.rawData.params.filter(param => Boolean(param.value))
                .map(param => param.value)
                .join(', ');
        }

        this.setConclusionsInfo();
    }

    private setConclusionsInfo() {
        if (!this.rawData.conclusions) {
            return;
        }

        this.conclusions = this.rawData.conclusions.map(con => {
            const newUrl = RoutesStorage.Conclusion.new(this.id, con.technical_card.id);

            const id = con && con.conclusion && con.conclusion.id;
            const techcardId = con && con.technical_card.id;

            return {
                id: con.conclusion && con.conclusion.id,
                isBlank: con.conclusion && !(con.conclusion.number && con.conclusion.date),
                methodTitle: con && con.technical_card && con.technical_card.method.short_title,
                numberTitle: con.conclusion ? con.conclusion.number || 'Продолжить' : 'Оформить',
                date: con.conclusion && con.conclusion.date,
                statusTitle: con.conclusion && con.conclusion.status_title,
                scan: con.conclusion && con.conclusion.scan || null,
                withInspections: con.conclusion && con.conclusion.with_inspections || false,

                newUrl,
                viewUrl: con.conclusion && RoutesStorage.Conclusion.view(con.conclusion.id) || null,
                editUrl: id && RoutesStorage.Conclusion.edit(id, this.id, techcardId) || null,

                technicalCardId: con.technical_card.id,
            };
        });
    }
}
